import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Button, Grid, Paper, Stack, TableBody,
  TableCell, styled, tableCellClasses, TableRow,
  IconButton, Switch
} from "@mui/material";
import AddNewUser from "./AddNewUser";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/system";
import Form from "../common/Form";
import Controls from "../controls/Controls";
import useForm from "../common/useForm";
import UseTable from "../common/UseTable";
import { useState } from "react";
import { format } from "date-fns";
import Popup from "../common/Popup";
import Notification from "../common/Notification";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, loadAllUsers } from "../../store/users";
import { BorderColor } from "@mui/icons-material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    whiteSpace: "nowrap",
  },
}));

const headCells = [
  { id: "id", label: "S. No.", width: 90 },
  { id: "addedDateTime", label: "Date & Time", width: 90 },
  {
    id: "firstName",
    label: "First Name",
    width: 150,
    editable: true,
  },
  {
    id: "lastName",
    label: "Last Name",
    width: 150,
    editable: true,
  },
  {
    id: "email",
    label: "Email",
    width: 150,
    editable: true,
  },
  {
    id: "mobile",
    label: "Mobile",
    width: 150,
    editable: true,
  },
  {
    id: "action",
    label: "Action",
    sortable: false,
  },
  {
    id: "status",
    label: "Status",
    sortable: false,
  },
];

const allUsers1 = [
  {
    id: 1,
    addedDateTime: new Date(),
    lastName: "Snow",
    firstName: "Jon",
    email: "snow@gmail.com",
    mobile: "",
    status: false,
  },
];

export default function ManageUsers() {
  const [open, setOpen] = useState(false);
  const [addUserPopup, setAddUserPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [pageSize, setPageSize] = useState(5);
  const [pageIndex, setPageIndex] = useState(1);
  const [allUsers, setAllUsers] = useState([]);

  const [notify, setNotify] = useState({ isOpen: false, message: "", type: "", });
  const [filterFn, setFilterFn] = useState({ fn: (items) => { return items; } });

  const allUsersSelector = useSelector(getAllUsers);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAllUsers(pageSize, pageIndex));
  }, []);

  useEffect(() => {
    setAllUsers(allUsersSelector);
  }, [allUsersSelector]);

  const {
    TblContainer,
    TblHeader,
    TblPagination,
    tblDataAfterPaginationAndSorting,
  } = UseTable(allUsers, headCells, filterFn);

  const handleAddUser = (obj) => {
    if (obj === "save") dispatch(loadAllUsers(pageSize, pageIndex));
    else setSelectedUser(obj);
    setAddUserPopup(!addUserPopup);
  };

  const handleSwitchChange = (item) => {

    setNotify({                   // ye useeffect me jayega 
      isOpen: true,
      message: `${item?.status === false ? "User Activated Successfully" : "User Deactivated Successfully"}`,
      type: "success",
    });
    setAllUsers((prevUsers) =>    // iski jagah dispatch api ayegi
      prevUsers.map((user) =>
        user.id === item.id ? { ...user, status: !user.status } : user
      )
    );
  };

  return (
    <Box sx={{ height: "100%" }}>
      <Box display="flex" alignItems="right" justifyContent="right" mb={2}>
        <Controls.Button
          text="Add New"
          size="small"
          onClick={() => handleAddUser(null)}
          variant="outlined"
          startIcon={<AddIcon />}
          sx={{
          
            color: 'black',
            border: "1px solid black",
            '&:hover': {
              backgroundColor: 'black',
              color: 'white',

            }
          }}
        />
      </Box>
      <Paper sx={{ overflow: "auto" }}>
        <TblContainer>
          <TblHeader />
          <TableBody>
            {tblDataAfterPaginationAndSorting().map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.id}</TableCell>
                <StyledTableCell>
                  {item?.addedDateTime && format(new Date(item.addedDateTime), "MM/dd/yyyy, h:mma")}
                </StyledTableCell>
                <StyledTableCell>{item.firstName}</StyledTableCell>
                <StyledTableCell>{item.lastName}</StyledTableCell>
                <StyledTableCell>{item.email}</StyledTableCell>
                <StyledTableCell>{item.mobile}</StyledTableCell>
                <TableCell>
                  <IconButton
                    color="primary"
                    component="span"
                    onClick={() => handleAddUser(item)}
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  <Switch
                    checked={item.status}
                    onChange={() => handleSwitchChange(item)}
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                        color: '#12d412',
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#12d412',
                      },
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        {/* <TblPagination /> */}
      </Paper>

      <Popup
        title={selectedUser ? "Edit User" : "Add User"}
        openPopup={addUserPopup}
        setOpenPopup={setAddUserPopup}
        handleOpenPopup={handleAddUser}
        size="lg"
      >
        <AddNewUser
          setOpenPopup={addUserPopup}
          selectedUser={selectedUser}
          setNotify={setNotify}
          handleAddUser={handleAddUser}
        />
      </Popup>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}
